import React, { useRef } from 'react';
import mergeCallbacks from 'utils/ui/mergeCallbacks';
import * as MenuListUI from 'components/MenuList';
import { useMenuContext } from './Menu';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function MenuItem(_ref) {
  var icon = _ref.icon,
    isDisabled = _ref.isDisabled,
    onClick = _ref.onClick,
    children = _ref.children;
  var itemRef = useRef(null);
  var _useMenuContext = useMenuContext(),
    itemList = _useMenuContext.itemList;
  var _itemList$useItem = itemList.useItem({
      ref: itemRef,
      text: children,
      value: children,
      disabled: isDisabled
    }),
    id = _itemList$useItem.id,
    select = _itemList$useItem.select,
    highlight = _itemList$useItem.highlight,
    useHighlighted = _itemList$useItem.useHighlighted;
  return /*#__PURE__*/_jsx(MenuListUI.Item, {
    ref: itemRef,
    id: id,
    as: "div",
    role: "menuitem",
    "aria-disabled": isDisabled,
    onClick: mergeCallbacks(select, onClick),
    onMouseEnter: highlight,
    onMouseLeave: itemList.clearHighlightedItem,
    children: /*#__PURE__*/_jsxs(MenuListUI.Link, {
      forwardedAs: "span",
      isDisabled: isDisabled,
      isHighlighted: useHighlighted(),
      children: [icon && /*#__PURE__*/_jsx(MenuListUI.ItemIcon, {
        name: icon
      }), children]
    })
  });
}
export default MenuItem;